// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-upload__dropzone{border:1px solid #ccc;border-radius:5px;padding:5rem;width:100%;max-width:600px;margin:0 auto}.image-upload__dropzone--active{background:#f5f5f5}", ""]);
// Exports
module.exports = exports;
